
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9987_8041)"}},[_c('path',{attrs:{"d":"M22.6 2.54c-.26-1-1.04-1.78-2.04-2.06-1.8-.49-9.02-.49-9.02-.49s-7.22 0-9.02.49C1.52.76.75 1.54.48 2.54.15 4.39-.01 6.26 0 8.14c-.01 1.88.15 3.75.48 5.59.26 1 1.04 1.78 2.04 2.06 1.8.49 9.02.49 9.02.49s7.22 0 9.02-.49c1-.27 1.78-1.05 2.04-2.06.33-1.85.49-3.72.48-5.59.01-1.88-.15-3.75-.49-5.59l.01-.01zM9.18 11.56V4.7l6.03 3.43-6.03 3.43z","fill":"#1F4053"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9987_8041"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h23.09v16.27H0z"}})])])])
          )
        }
      }
    